import { render, staticRenderFns } from "./MyDialog.vue?vue&type=template&id=62607fc8&scoped=true"
import script from "./MyDialog.vue?vue&type=script&lang=js"
export * from "./MyDialog.vue?vue&type=script&lang=js"
import style0 from "./MyDialog.vue?vue&type=style&index=0&id=62607fc8&prod&scoped=true&lang=css"
import style1 from "./MyDialog.vue?vue&type=style&index=1&id=62607fc8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62607fc8",
  null
  
)

export default component.exports